import { useEffect, useState } from 'react'
import getDateDiff from '@bt-react/libs/getDateDiff'

const useIsTalkLive = (date: string) => {

  const [ isTalkLive, setIsTalkLive ] = useState(false)

  useEffect(() => {

    setIsTalkLive(getDateDiff(date).hasPassed || false)

  }, [ date ])

  return isTalkLive

}

export default useIsTalkLive